//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {
    
    //Use strict mode
    'use strict';

    /**
     * @class am.TraductionSelectorView #172
     */
    module.TraductionSelectorView = L.Control.extend({
        // Private attributes
        _formElementPromise: undefined, // Promise which will resolve to the form's DOM element when the widget is completely loaded
        _inputFieldPromise: undefined,  // Promise which will resolve to the input field's DOM element when the widget is completely loaded

        /**
         * Class constructor
         * @constructor
         *
         * @param {Object} options - Same options as for class L.Control
         */
        initialize: function(options) {
            // Call parent constructor
            L.Control.prototype.initialize.call(this, options);
            this._options=options;
            // Initialize the private properties
            this._formElementPromise = am.utils.controllablePromise();
            this._inputFieldPromise  = am.utils.controllablePromise();
        },

        /**
         * Function called when adding the widget to the map.
         *
         * @param {L.Map} map - Leaflet map in which the widget should be added
         * @return {HTMLElement} - DOM element corresponding to the widget
         */
        onAdd: function(map) {
            // Create the widget
            var container = L.DomUtil.create('div', 'am-widget');
            var _this = this;
            var sCurrentLang =am.translator.getLanguage(true);
            am.templateManager.fillElementWithTemplate(container, 'traduction-selector-field', {"languageA":_this._options.language,"sCurrentLang":sCurrentLang}, function($container) {
                var $currentLangButton  = $container.find('#current-lang-button');
                var $langList  = $container.find('.traduction-list');
                var $changeLangButton =$langList.find('.am-traduction-selector-button');
                // $currentLangButton.click(function(){
                //     if (!$langList.hasClass('show')){
                //         $langList.addClass('show');
                //         $currentLangButton.removeClass('show');
                //     }else{
                //         $langList.removeClass('show')
                //         $currentLangButton.addClass('show');
                //     }
                // });
                $changeLangButton.click(function(e){
                    am.utils.addUrlParameter("lang",$(this).attr('value'));
                    document.location.reload(false);
                });
                
            });

            // Prevent interacting with the map when clicking on the widget
            am.utils.preventMapInteractionOverElement(container);

            return container;
        }
    });

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Factory function returning an instance of am.TraductionSelectorView
     * 
     * @param {Object} options - Same options as for class L.Control
     * @return {am.TraductionSelectorView} - New instance of class am.TraductionSelectorView
     */
    module.traductionSelectorView = function(options) {
        return new am.TraductionSelectorView(options);
    };

    return module;

})(am.utils || {});